<template>
  <div class="content">
    <el-menu default-active="manage" class="el-menu-demo" mode="horizontal" :router="true">
      <el-menu-item index="list">创建课程</el-menu-item>
      <el-menu-item index="manage" class="is-active">管理课程</el-menu-item>
    </el-menu>

    <div class="tab-item">
      <div class="release">
        <div class="status_wrapper">
          <span class="status">状态：</span>
          <ul>
            <li :class="{'active': activeIndex == 1}" @click="selectType(1)">全部</li>
            <li :class="{'active': activeIndex == 2}" @click="selectType(2)">已通过</li>
            <li :class="{'active': activeIndex == 3}" @click="selectType(3)">审核中</li>
            <li :class="{'active': activeIndex == 4}" @click="selectType(4)">未通过</li>
            <li :class="{'active': activeIndex == 5}" @click="selectType(5)">下架</li>
          </ul>
        </div>
        <div class="up_item" v-for="item in list" :key="item.id">
          <div class="up_item_info">
            <div class="course_img">
              <img :src="item.cover" v-if="item.cover" />
              <img src="@/assets/imgs/u5260.jpg" v-else />
              <el-tag type="success" effect="dark">{{item.status | status}}</el-tag>
            </div>
            <div class="detail">
              <span class="course_title" :title="item.title">{{item.title}}</span>
              <span>{{common.time(item.published_time*1000)}}</span>
              <span>下载次数：{{item.download_num}}</span>
              <span v-if="item.status==5">
                应用审核未通过
                <a>详情</a>
              </span>
            </div>
            <div class="tools">
              <el-button type="primary" size="small" @click="publish(item.id)">编辑</el-button>
              <el-button type="danger" size="small" @click="deleteCourse(item.id)">删除</el-button>
            </div>
          </div>

        </div>
      </div>
      <el-pagination @current-change="handle" background layout="total, prev, pager, next" :total="paging.total" :page-size="paging.limit" v-show="paging" v-if="list"
        hide-on-single-page></el-pagination>
    </div>
  </div>
</template>

<script>
import CourseAdd from "@/views/admin/course-add";
import { getCourseList, removeCourse } from "@/api/course";
export default {
  components: {
    CourseAdd
  },
  inject: ['reload'],
  methods: {
    handleClick(tab, event) {
    },
    close() {
      this.dialogTableVisible = false;
    },
    publish(id) {
      this.$router.push({ name: "contest-base", params: { competitionId: id }, query: { from: this.$route.name } });
    },
    selectType(index) {
      this.activeIndex = index;
    },
    deleteCourse(id) {
      var that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          removeCourse(id).then(response => {
            this.$message.success({
              message: "删除成功",
            });
            that.handle()
          });
        })
        .catch(() => { });
    },
    handle(val) {
      var params = this.$route.params;
      params.page = val;
      params.status = 4;
      getCourseList(params).then(response => {
        this.list = response.data.course.data;
        this.paging = response.data.course.paging;
      });
    }
  },
  data() {
    return {
      options: [
        {
          value: "全部内容",
          label: "全部内容"
        },
        {
          value: "视频双师",
          label: "视频双师"
        },
        {
          value: "项目实训",
          label: "项目实训"
        },
        {
          value: "综合教学",
          label: "综合教学"
        },
        {
          value: "学习路径",
          label: "学习路径"
        }
      ],
      paging: {
        page: null,
        limit: null,
        total: null
      },
      value: "",
      activeName: "create",
      dialogTableVisible: false,
      dialogFormVisible: false,
      isFullscreen: true,
      activeIndex: 1,
      list: null,
    };
  },
  filters: {
    status: function (value) {
      // let status = '';
      switch (value) {
        case 2:
          status = "未审核";
          break;
        case 4:
          status = "已通过";
          break;
        case 6:
          status = "下架";
          break;
        case 5:
          status = "未通过";
          break;
        case 3:
          status = "审核中";
          break;
        default:
          status = "未发布";
      }
      return status;
    }
  },
  beforeRouteEnter(to, from, next) {
    let params = {
      status: "4"
    };
    getCourseList(params).then(response => {
      next(vm => {
        vm.list = response.data.course.data;
        vm.paging = response.data.course.paging;
      });
    });

    // Promise.all([getCourseList(params), getCourseList(params1)]).then(result =>
    //   next(vm => {
    //     // 執行結果會按照上面順序放在 result 數組內，所以 result[0]，代表第一個函數的 resolve 結果
    //     vm.list = result[0].data.list.data;
    //     vm.paging = result[0].data.list.paging;
    //     vm.list1 = result[1].data.list.data;
    //     vm.paging1 = result[1].data.list.paging;
    //   })
    // );
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}
.el-card {
  line-height: 32px;
  margin-bottom: 20px;
}
.course_title {
  color: #000000;
  font-size: 16px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}

.list_info {
  overflow: hidden;
}
.list_info span {
  display: inline-block;
  margin-right: 15px;
}
.tools {
  height: 100%;
  text-align: right;
  line-height: 64px;
}
.status_wrapper {
  overflow: hidden;
}
.status {
  float: left;
  width: 50px;
  height: 29px;
  text-align: center;
  line-height: 30px;
}

.tab-item ul {
  width: 800px;
  overflow: hidden;
  float: left;
}
.tab-item ul li {
  margin-left: 10px;
  display: block;
  padding: 5px 15px;
  cursor: pointer;
  float: left;
}
.active {
  background-color: #1e9fff;
  color: #ffffff;
}
.tab-item {
  overflow: hidden;
}
.up_item {
  width: 100%;
  height: 145px;
  margin-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
}
.course_img {
  width: 240px;
  float: left;
  position: relative;
}
.up_item_info .el-tag {
  width: 55px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  padding: 0 0 5px 5px;
  position: absolute;
  top: 0;
  right: 0px;
  border-radius: 0px 0px 0px 20px;
}
.up_item img {
  width: 240px;
  height: 135px;
  float: left;
}
.up_item .detail {
  float: left;
  width: 600px;
  height: 135px;
  padding: 5px 10px;
  overflow: hidden;
  box-sizing: border-box;
}
.release .tools {
  height: 135px;
  line-height: 135px;
}
.up_item_info span {
  width: 100%;
  display: block;
  margin-bottom: 15px;
  float: left;
}
#add {
  margin-bottom: 10px;
}
.add_title {
  font-size: 16px;
}
.el-menu {
  margin-bottom: 15px;
}
</style>
